const UNAVAILABLE_PAYMENT_SENTINELS = new Set(['', 'non disponible', 'indisponible', 'n/a', 'na']);

const MOBILE_PAYMENT_NUMBER_KEYS = {
  airtel: 'airtel',
  mtn: 'mtn',
  orange: 'orange',
  mpesa: 'mpesa',
};

const MOBILE_PAYMENT_METHOD_DEFINITIONS = [
  { key: 'airtel', id: 'airtel_money', name: 'Airtel Money' },
  { key: 'mtn', id: 'mtn_money', name: 'MTN Mobile Money' },
  { key: 'orange', id: 'orange_money', name: 'Orange Money' },
  { key: 'mpesa', id: 'mpesa', name: 'M-Pesa' },
];

export const MOBILE_MONEY_METHOD_IDS = MOBILE_PAYMENT_METHOD_DEFINITIONS.map((item) => item.id);

export const hasConfiguredPaymentNumber = (value) => {
  const normalizedValue = String(value || '').trim().toLowerCase();
  return Boolean(normalizedValue) && !UNAVAILABLE_PAYMENT_SENTINELS.has(normalizedValue);
};

export const resolvePaymentMethodFlags = (settings = {}) => {
  const paymentNumbers = settings?.payment_numbers || {};
  const rawFlags = settings?.payment_methods || {};

  const resolveBoolean = (key, fallback) => {
    const value = rawFlags?.[key];
    return typeof value === 'boolean' ? value : fallback;
  };

  let airtel = resolveBoolean('airtel', hasConfiguredPaymentNumber(paymentNumbers.airtel));
  let mtn = resolveBoolean('mtn', hasConfiguredPaymentNumber(paymentNumbers.mtn));
  let orange = resolveBoolean('orange', hasConfiguredPaymentNumber(paymentNumbers.orange));
  let mpesa = resolveBoolean('mpesa', hasConfiguredPaymentNumber(paymentNumbers.mpesa));
  const stripe = false;
  const manual = false;
  const mobileMoney = resolveBoolean('mobile_money', Boolean(airtel || mtn || orange || mpesa));

  if (!mobileMoney) {
    airtel = false;
    mtn = false;
    orange = false;
    mpesa = false;
  }

  return {
    stripe,
    mobile_money: mobileMoney,
    airtel,
    mtn,
    orange,
    mpesa,
    manual,
  };
};

export const buildAvailableMobileMoneyMethods = (settings = {}) => {
  const paymentNumbers = settings?.payment_numbers || {};
  const flags = resolvePaymentMethodFlags(settings);

  return MOBILE_PAYMENT_METHOD_DEFINITIONS
    .map(({ key, id, name }) => ({
      id,
      key,
      name,
      number: paymentNumbers[MOBILE_PAYMENT_NUMBER_KEYS[key]],
      available: Boolean(flags.mobile_money && flags[key]),
    }))
    .filter((item) => item.available);
};
